"use client"

import { useEffect } from "react"
import Cookies from "js-cookie"

export function HighlightCookie() {
  const sessionSecureID = global.window?.localStorage.getItem("sessionSecureID")

  useEffect(() => {
    if (sessionSecureID) {
      Cookies.set("sessionSecureID", sessionSecureID)
    }
  }, [sessionSecureID])

  return <></>
}
